<template>
  <div class="e-block-wrap">
    <div class="e-block e-block--flow">
      <div class="e-block__scroll" :style="{ minHeight: containerHeight }">
        <div class="e-block__title">Based on previously sized model, there are multiple NEMA 4 rated cabinet options.</div>
        <div class="e-selector-label">Choose one:</div>
        <div class="e-row e-row--gutters">
          <div class="e-col-4 e-col-sm-12" v-if="hasNema4">
            <div class="e-flow-selector e-flow-selector--nema" @click="proceed('N4', imgNema4)">
              <img :src="imgNema4" alt="NEMA 4">
              <div class="e-flow-selector__nema-title">NEMA 4</div>
              <div class="e-flow-selector__nema-text">Brushed steel waterproof cabinet</div>
            </div>
          </div>
          <div class="e-col-4 e-col-sm-12" v-if="hasNema4X">
            <div class="e-flow-selector e-flow-selector--nema"  @click="proceed('N4X', imgNema4x)">
              <img :src="imgNema4x" alt="NEMA 4X">
              <div class="e-flow-selector__nema-title">NEMA 4X</div>
              <div class="e-flow-selector__nema-text">304 stainless steel waterproof cabinet</div>
            </div>
          </div>
          <div class="e-col-4 e-col-sm-12" v-if="hasNema4X">
            <div class="e-flow-selector e-flow-selector--nema"  @click="proceed('N4X6', imgNema4x)">
              <img :src="imgNema4x" alt="NEMA 4X">
              <div class="e-flow-selector__nema-title">NEMA 4X6</div>
              <div class="e-flow-selector__nema-text">314 stainless steel waterproof cabinet</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="e-bottom-navbar">
      <div class="e-row">
        <div class="e-col-auto e-col-sm-12">
          <button class="e-btn e-btn--prev" @click.prevent="previous">Previous</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { finalResultWithCabinet, selectCabinetOptions } from '@/utils/commercial-flow';

export default {
  components: {},
  name: 'FlowSelector',
  data() {
    return {
      imgNema4: `${process.env.VUE_APP_PATH}/img/nema4.png`,
      imgNema4x: `${process.env.VUE_APP_PATH}/img/nema4x.png`,
    };
  },
  mounted() {},
  computed: {
    ...mapState(['selectedFlow', 'containerHeight', 'selectedProduct']),
    ...mapGetters(['currentQuestion', 'filter']),
    hasNema4() {
      return this.selectedProduct.nemaCabinets.indexOf('N4') > -1;
    },
    hasNema4X() {
      return this.selectedProduct.nemaCabinets.indexOf('N4X') > -1;
    },
    hasNema4X6() {
      return this.selectedProduct.nemaCabinets.indexOf('N4X6') > -1;
    },
    has3phase() {
      return this.filter?.phase === 3;
    },
  },
  methods: {
    ...mapActions(['nextQuestion', 'previousQuestion', 'addParamToFilter', 'setSelectedFlow', 'setSelectedCabinet', 'setSelectedCabinetOptions']),
    previous() {
      this.previousQuestion();
    },
    proceed(cabinet, img) {
      this.setSelectedCabinet({ name: cabinet, img });
      this.setSelectedCabinetOptions([]);
      const nextId = this.has3phase ? selectCabinetOptions : finalResultWithCabinet;
      this.nextQuestion(nextId);
    },
  },
};
</script>

<style lang="scss">

</style>
